<template>
	<form @submit.prevent="submit">
		<v-row>
			<v-col>
				<smart-input label="utm_source" v-model="itemsFilter.utm_source"/>
				<smart-input label="utm_medium" v-model="itemsFilter.utm_medium"/>
				<smart-input label="utm_content" v-model="itemsFilter.utm_content"/>
			</v-col>
			<v-col>
				<lotteries-select :clearable="true" label="בחר הגרלה" :items="lotteries"
					v-model="itemsFilter.lottery_id"/>
				<v-select clearable v-if="packages && packages.length > 0" label="בחר חבילה" item-value="id" item-text="title"
					:items="packages" v-model="itemsFilter.package_id"/>
				<v-btn left color="success" class="mx-auto ml-5" @click="sendParams">סנן טבלה</v-btn>
				<v-btn left color="success" class="mx-auto" type="submit">הורד קובץ אקסל</v-btn>
				<v-spacer />
				<v-btn class="mt-6" color="primary" @click="clearForm">נקה סינון</v-btn>
			</v-col>
		</v-row>
	</form>
</template>

<script>
	import LotteryModule from "../../store/modules/Lottery.module";
	import LotteriesSelect from "../lotteries/LotteriesSelect";

	export default {
		name: "clients-filter",
		components: {LotteriesSelect},
		data() {
			return {
				itemsFilter: {
					utm_source:null,
					utm_medium:null,
					utm_content:null,
					lottery_id:null,
					package_id:null
				},

			};
		},
		computed: {
			lotteries() {
				return this.$store.state.LotteryModule.lotteries;
			},
			packages() {
				return this.$store.state.LotteryModule.lottery.packages;
			},
			basicUrl() {
				return this.$store.state.ConfigModule.request.baseUrl;
			}
		},
		watch: {
			value: {
				deep: true,
				immediate: true,
				handler() {
					this.filters = Object.assign({}, this.filters, this.value);
				}
			},
			"itemsFilter.lottery_id": {
				async handler() {
					if (this.itemsFilter.lottery_id) {
						await this.$store.dispatch(LotteryModule.types.GET, this.itemsFilter.lottery_id);
					}
				}

			}
		},
		methods: {
			submit() {
				window.open(`${this.basicUrl}/client/export?
				${this.itemsFilter.utm_source ? "utm_source=" + this.itemsFilter.utm_source + "&" : ""}
				${this.itemsFilter.utm_medium ? "utm_medium=" + this.itemsFilter.utm_medium + "&" : ""}
				${this.itemsFilter.utm_content ? "utm_content=" + this.itemsFilter.utm_content + "&" : ""}
				${this.itemsFilter.lottery_id ? "lottery_id=" + this.itemsFilter.lottery_id + "&" : ""}
				${this.itemsFilter.package_id ? "package_id=" + this.itemsFilter.package_id + "&" : ""}`);
			},
			sendParams() {
				let filters = {};

				Object.keys(this.itemsFilter).forEach((key) => {
					if (!!this.itemsFilter[key]) {
						filters[key] = this.itemsFilter[key];
					}
				});
				this.$emit("input",filters);
			},
			clearForm(){
				this.itemsFilter = {
					utm_source:null,
					utm_medium:null,
					utm_content:null,
					lottery_id:null,
					package_id:null
				};
				this.sendParams();
			}
		},
		async created() {
			await this.$store.dispatch(LotteryModule.types.FETCH);
		}
	};
</script>

<style scoped>

</style>
